export default defineAppConfig({
  icon: {
    mode: 'css',
    cssLayer: 'base',
  },
  ui: {
    header: {
      slots: {
        root: 'border-0',
      },
    },
    button: {
      slots: {
        base: [
          'rounded-full transition-transform hover:scale-105 px-6 cursor-pointer',
        ],
      },
      variants: {
        size: {
          xl: {
            base: 'px-6',
          },
        },
        variant: {
          link: 'px-0 hover:scale-100',
        },
      },
    },
    colors: {
      primary: 'brand-blue',
      secondary: 'brand-red',
      payment_success: 'payment_success',
      waiting_stock: 'waiting_stock',
      waiting_shipping: 'waiting_shipping',
      order_delivered: 'order_delivered',
      order_canceled: 'order_canceled',
      delivered_to_cs: 'delivered_to_cs',
      partial_delivery_in_progress: 'partial_delivery_in_progress',
      partial_delivery_to_cs: 'partial_delivery_to_cs',
      delivered_to_librairie: 'delivered_to_librairie',
      awaiting_bl_signature: 'awaiting_bl_signature',
      awaiting_payment: 'awaiting_payment',
      payment_failed: 'payment_failed',
      waiting_recovery: 'waiting_recovery',
      tertiary: 'tertiary',
    },
  },
})
